<template>
  <div>
    <!-- HEADER -->
    <v-layout>
      <v-flex lg2>
        <rating-frame :rating="franchise.rating"/>
      </v-flex>
      <v-spacer/>
      <v-flex lg6>
        <!-- ROW 1.1: NAME, EDIT BUTTON -->
        <v-layout
          align-center
          justify-space-between>
          <span class="headline">
            <router-link
              :to="{ name: 'subcontractor',
                     params: { id: franchise.subcontractor.id } }"
              class="clickable">
              {{ franchise.subcontractor.name }}
            </router-link>
            <v-icon>chevron_right</v-icon>
            <span>{{ franchise.name }}</span>
          </span>
          <v-btn
            class="ma-0"
            flat
            icon
            @click="edit">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-layout>
        <!-- ROW 1.2: INSURANCE CERTS VALIDITY, RATING -->
        <v-layout
          align-center
          justify-space-between>
          <v-flex shrink>
            <v-tooltip
              v-if="franchise.hasValidInsurCerts"
              right>
              <v-icon
                slot="activator"
                class="my-2"
                large>
                check
              </v-icon>
              <span>Insurance certificates are VALID today.</span>
            </v-tooltip>
            <v-tooltip
              v-else
              right>
              <v-icon
                slot="activator"
                class="my-2"
                large>
                warning
              </v-icon>
              <span>Insurance certificates are NOT valid.</span>
            </v-tooltip>
          </v-flex>
          <v-flex
            v-if="franchise.lat && franchise.lng"
            shrink>
            <span class="mr-2">
              <b>GPS</b>
            </span>
            <span>
              {{ franchise.lat.toFixed(6) }}, {{ franchise.lng.toFixed(6) }}
            </span>
          </v-flex>
        </v-layout>
        <v-divider/>
        <!-- ROW 2: DETAILS -->
        <v-layout class="mt-5">
          <v-flex>
            <franchise-details
              :dtls="franchise.details"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
        <!-- ROW 3: INSURANCES CERTIFICATES -->
        <v-layout class="mt-3">
          <v-flex>
            <insurances-table
              :certificates="franchise.insurancesCerts"
              :loading="false"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
        <!-- ROW 4: TICKETS CERTIFICATES -->
        <v-layout class="mt-3">
          <v-flex>
            <tickets-table
              :certificates="franchise.ticketsCerts"
              :loading="false"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
        <!-- ROW 4: WORKERS -->
        <v-layout class="mt-3">
          <v-flex>
            <workers-table
              :workers="franchise.workers"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
        <!-- ROW 5: STOCK -->
        <v-layout class="mt-3">
          <v-flex>
            <stock-table
              :stock="franchise.stock"
              @refresh="refresh"/>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg3/>
    </v-layout>
    <!-- EDIT DIALOG -->
    <edit-dialog
      v-model="dialog"
      :franchise="{
        lat: franchise.lat,
        lng: franchise.lng,
        name: franchise.name
      }"
      @refresh="refresh"/>
  </div>
</template>

<script>
import EditDialog from "./Franchise/EditDialog";
import FranchiseDetails from "./Franchise/Details";
import RatingFrame from "./SharedComponents/RatingFrame";
import StockTable from "./Franchise/StockTable";
import WorkersTable from "./Franchise/WorkersTable";
import InsurancesTable from "./Franchise/InsurancesTable";
import TicketsTable from "./Franchise/TicketsTable";

export default {
  components: {
    EditDialog,
    FranchiseDetails,
    InsurancesTable,
    RatingFrame,
    StockTable,
    WorkersTable,
    TicketsTable
  },
  filters: {
    displayRating (rating) {
      return rating ? parseFloat(rating).toFixed(1) : "";
    }
  },
  data () {
    return {
      // Boolean to toggle the edit dialog
      dialog: false,
      franchise: {
        details: [],
        insurancesCerts: [],
        location: {},
        name: "< Name >",
        rating: null,
        stock: [],
        subcontractor: {
          id: 0,
          name: "< Subcontractor >"
        },
        ticketsCerts: [],
        workers: []
      }
    };
  },
  created () {
    // Get information on the franchise to be edited
    const { id } = this.$route.params;
    this.$http.get(`/api/franchises/${id}`).
      then((r) => Object.assign(this.franchise, r.data));
  },
  methods: {
    // When the edition mode is trigerred, open the dialog
    edit () {
      this.editedFranchise = Object.assign({}, this.franchise);
      this.dialog = true;
    },
    refresh () {
      const { id } = this.$route.params;
      this.$http.
        get(`/api/franchises/${id}`).
        then((r) => Object.assign(this.franchise, r.data));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchise.vue